import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../atoms/Text/Text';
import { Header, Label, Row, RowHeadline, Rows, Titles, Value, Wrapper } from './ProductSummary.styles';
export const ProductSummary = ({ className, 'data-testid': testId, headline, rows, subline })=>/*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(Header, {
                children: /*#__PURE__*/ _jsxs(Titles, {
                    children: [
                        Boolean(headline) && /*#__PURE__*/ _jsx(Text, {
                            isBold: true,
                            children: headline
                        }),
                        Boolean(subline) && /*#__PURE__*/ _jsx(Text, {
                            size: "S",
                            children: subline
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Rows, {
                children: rows?.map(({ headline: rowHeadline, label, value })=>/*#__PURE__*/ _jsxs(Row, {
                        $isHeadline: Boolean(rowHeadline),
                        children: [
                            Boolean(rowHeadline) && /*#__PURE__*/ _jsx(RowHeadline, {
                                children: rowHeadline
                            }),
                            Boolean(label) && /*#__PURE__*/ _jsx(Label, {
                                children: label
                            }),
                            Boolean(value) && /*#__PURE__*/ _jsx(Value, {
                                children: value
                            })
                        ]
                    }, `${rowHeadline}-${label}-${value}`))
            })
        ]
    });

//# sourceMappingURL=ProductSummary.js.map